import { useEffect, useState } from "react";
import adminsApi from "../../../../../configs/apis/admins";
import CompanyGroupDialogComponent from "./companyGroupDialog.component";

export default function CompanyGroupDialogContainer({
  selected,
  open,
  handleClose,
  handleSubmit,
}) {
  const [allCompany, setAllCompany] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    adminsApi
      .getCompanyDropdown()
      .then((response) => {
        setAllCompany(response.data);
      });
  }, []);

  return (
    <CompanyGroupDialogComponent
      open={open}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      allCompany={allCompany}
      selected={selected}
      isLoading={isLoading}
    />
  );
}
